export const Two = 'X';